const ESCAPE_MAP: { [key: string]: string } = {
  '\\': '\\\\', // Escape backslashes
  '\n': '\\n', // Escape newlines
}

const UNESCAPE_MAP: { [key: string]: string } = {
  '\\\\': '\\', // Unescape backslashes
  '\\n': '\n', // Unescape newlines
}

/**
 * Escapes backslashes and newlines in the given content.
 *
 * @param content The input string to escape.
 * @returns The escaped string.
 */
export const escapeContent = (content: string): string => {
  if (!content) {
    return ''
  }

  return content.replace(/[\\\n]/g, match => ESCAPE_MAP[match] || match)
}

/**
 * Unescapes backslashes and newlines in the given content.
 *
 * @param content The input string to unescape.
 * @returns The unescaped string.
 */
export const unescapeContent = (content: string): string => {
  if (!content) {
    return ''
  }

  return content.replace(/\\\\|\\n/g, match => UNESCAPE_MAP[match] || match)
}
